module.exports = __webpack_public_path__ + "static/media/not-supported-img.d4929f98.png";